import { useEffect } from 'react'
import useSWR from 'swr'
import WriteLog from '../libs/WriteLog';

function useSchedule(custCode, token, addrSeq) {
  const fetcher = (...args) => fetch(...args).then(res => res.json())
  //work_order/history/{customer_id}
  
    WriteLog("useSchedule->Endpoint",process.env.REACT_APP_SERVER_BASE_URL +'/work_order/schedule/'+custCode+'/addr_seq/'+addrSeq);
    const { data, error } = useSWR([process.env.REACT_APP_SERVER_BASE_URL +'/work_order/schedule/'+custCode+'/addr_seq/'+ addrSeq, 
        {   method: 'GET',
            headers: {
                        'Authorization': token,
                    } 
        }
    ], fetcher)
    if(error) WriteLog("useSchedule->Error", error);
    useEffect(() => {        
      // if user data not yet there (fetch in progress, logged in or not) then don't do anything yet    
      if (!data){     
        return
      } 
    }, [data])
    return {
      schedules: data,
      isLoading: !error && !data,
      isError: error
    }    
}
export default useSchedule